var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.009,
    height: 38.887,
    viewBox: "0 0 42.009 38.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_16623",
    x: 0,
    y: 0,
    width: 42.009,
    height: 38.887,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(9.527 6.631)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.53, -6.63)",
    filter: "url(#Path_16623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16623-2",
    "data-name": "Path 16623",
    d: "M15.684,5.4l9.3,15.533a2.2,2.2,0,0,1-1.879,3.3H4.5a2.2,2.2,0,0,1-1.878-3.3L11.927,5.4a2.2,2.2,0,0,1,3.757,0Z",
    transform: "translate(7.2 3.15)",
    fill: "#fff",
    stroke: "#9b2323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51232",
    "data-name": "Group 51232",
    transform: "translate(11.478 6.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16624",
    "data-name": "Path 16624",
    d: "M18,13.5v6.265",
    transform: "translate(-18 -13.5)",
    fill: "none",
    stroke: "#93312a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16625",
    "data-name": "Path 16625",
    d: "M18,25.5h0",
    transform: "translate(-18 -16.119)",
    fill: "none",
    stroke: "#93312a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFailed);
export default __webpack_public_path__ + "static/media/report-failed.f542fe4b5878e4b0659eada35349d64f.svg";
export { ForwardRef as ReactComponent };